import React from 'react';
import { useLocalization } from '../contexts/LocalizationContext';

const TermsOfUse: React.FC = () => {
  const { t } = useLocalization();
  
  return (
    <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">{t.termsOfUse.title}</h3>
      </div>
      
      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.termsOfUse.sections.scope.title}</h4>
        <p>
          {t.termsOfUse.sections.scope.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.termsOfUse.sections.dataSources.title}</h4>
        <p>
          {t.termsOfUse.sections.dataSources.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.termsOfUse.sections.accuracy.title}</h4>
        <p>
          {t.termsOfUse.sections.accuracy.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.termsOfUse.sections.acceptableUse.title}</h4>
        <p>
          {t.termsOfUse.sections.acceptableUse.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.termsOfUse.sections.intellectualProperty.title}</h4>
        <p>
          {t.termsOfUse.sections.intellectualProperty.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.termsOfUse.sections.privacy.title}</h4>
        <p>
          {t.termsOfUse.sections.privacy.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.termsOfUse.sections.liability.title}</h4>
        <p>
          {t.termsOfUse.sections.liability.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.termsOfUse.sections.changes.title}</h4>
        <p>
          {t.termsOfUse.sections.changes.content}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-900 mb-2">{t.termsOfUse.sections.governingLaw.title}</h4>
        <p>
          {t.termsOfUse.sections.governingLaw.content}
        </p>
        <p className="mt-2">
          <strong>{t.termsOfUse.sections.governingLaw.contact}</strong>
        </p>
      </div>
    </div>
  );
};

export default TermsOfUse;